import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { Products } from './pages/Products';
import { UploadProduct } from './pages/UploadProduct';
import { ProductDetails } from './pages/ProductDetails';
import { Orders } from './pages/Orders';
import { OrderDetails } from './pages/OrderDetails';
import { Wallet } from './pages/Wallet';
import { Withdraw } from './pages/Withdraw';
import { Profile } from './pages/Profile';
import { KYCVerification } from './pages/KYCVerification';
import { StorePreview } from './pages/StorePreview';
import { BankDetails } from './pages/BankDetails';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Dashboard data-id="element-3" />} data-id="element-2" />
        <Route path="/products" element={<Products data-id="element-5" />} data-id="element-4" />
        <Route path="/products/upload" element={<UploadProduct data-id="element-7" />} data-id="element-6" />
        <Route path="/products/:id" element={<ProductDetails data-id="element-9" />} data-id="element-8" />
        <Route path="/orders" element={<Orders data-id="element-11" />} data-id="element-10" />
        <Route path="/orders/:id" element={<OrderDetails data-id="element-13" />} data-id="element-12" />
        <Route path="/wallet" element={<Wallet data-id="element-15" />} data-id="element-14" />
        <Route path="/wallet/withdraw" element={<Withdraw data-id="element-17" />} data-id="element-16" />
        <Route path="/profile" element={<Profile data-id="element-19" />} data-id="element-18" />
        <Route path="/profile/kyc" element={<KYCVerification data-id="element-21" />} data-id="element-20" />
        <Route path="/profile/bank" element={<BankDetails data-id="element-23" />} data-id="element-22" />
        <Route path="/store-preview" element={<StorePreview data-id="element-25" />} data-id="element-24" />
      </Routes>
    </BrowserRouter>;
}